import { BaseTable, FooterMenu, HeaderMenu, PaginationData, TableHeader } from "components"
import moment from "moment"
import { useState } from "react"
import { DashboardFillType, PaginationState } from "types"
import { convertNumber, default_pagination_value, exportPdf } from "utils"
import { FilterCurrentPositionValue } from "./components/Section/FilterCurrentStockPosition"
import { useCurrentStockPerformence } from "./utils"
import { ExportExcelStockPerformanc, ExportPdfStockPerformance } from "./components/exports"


type FilterType = PaginationState & DashboardFillType & {
    category_id: string
}

export function CurrentStockPerformance() {
    const month = moment().format("MM")
    const year = moment().format("YYYY")
    const [fill, setFill] = useState<FilterType>({
        ...default_pagination_value,
        month,
        year,
        location_id: "",
        category_id: "",
    })

    const dataCurrentStockPerformence = useCurrentStockPerformence({
        date: `${fill.year}${fill.month}`,
        location_id: fill.location_id,
        category_id: fill.category_id,
        page: fill.page,
        limit: fill.limit
    })

    return (
        <section className="container my-5 flex flex-col gap-3">
            <HeaderMenu title="CURRENT STOCK PERFORMANCE" />

            <section className="flex flex-col gap-3">
                <section className="flex flex-col">
                    <FilterCurrentPositionValue
                        onChangeFilter={(res) => setFill({
                            ...fill,
                            month: moment(res.date_from).format("MM"),
                            year: moment(res.date_from).format("YYYY"),
                            location_id: res.location_id,
                            category_id: res.category_id?.toString() ?? "",
                        })}
                    />

                </section>

                <section className="flex flex-col mt-5">
                    <section className="grow">
                        <div className="max-h-[600px] overflow-y-auto">
                            <BaseTable>
                                <TableHeader>
                                    <tr>
                                        <th>CODE</th>
                                        <th>PRODUCT NAME</th>
                                        <th>SOH</th>
                                        <th>QTY ORDER</th>
                                        <th>STOCK IN</th>
                                        <th>STOCK OUT</th>
                                        <th>COMMITED</th>
                                    </tr>
                                </TableHeader>
                                <tbody>
                                    {dataCurrentStockPerformence?.data?.data?.map(performence => (
                                        <tr className="text-center">
                                            <td className="text-left">{performence?.product_barcode ?? "-"}</td>
                                            <td className="text-left">{performence?.product_name ?? "-"}</td>
                                            <td>{convertNumber(performence?.soh || 0)?.intoNormalAmount ?? "-"}</td>
                                            <td>{convertNumber(performence?.qty_order || 0)?.intoNormalAmount ?? "-"}</td>
                                            <td>{convertNumber(performence?.stock_in || 0)?.intoNormalAmount ?? "-"}</td>
                                            <td>{convertNumber(performence?.stock_out || 0)?.intoNormalAmount ?? "-"}</td>
                                            <td>{convertNumber(performence?.committed || 0)?.intoNormalAmount ?? "-"}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </BaseTable>
                        </div>
                        <div className="mt-5">
                            <PaginationData
                                data={{
                                    pagination_data: dataCurrentStockPerformence.pagination
                                }}
                                pagination={fill}
                                setPagination={setFill as React.Dispatch<React.SetStateAction<PaginationState>>}
                            />
                        </div>
                    </section>
                </section>

                <section className="mt-2">
                    <FooterMenu
                        export={{
                            actiontype: "export",
                            onClick: async () => {
                                const fullData = await dataCurrentStockPerformence.fetchAll();
                        
                                ExportExcelStockPerformanc({
                                    dataList: fullData.data || [],
                                });
                            }
                        }}
                        pdf={{
                            actiontype: "pdf",
                            onClick: async () => {
                                const fullData = await dataCurrentStockPerformence.fetchAll();
                            
                                exportPdf({
                                    documentComponent: (
                                        <ExportPdfStockPerformance
                                            dataList={fullData.data || []}
                                        />
                                    ),
                                    fileName: "Current_Stock_Performance"
                                });
                            }
                        }}
                    />
                </section>
            </section>
        </section>
    )
}
